<template>    
    <v-dialog
      v-model="dialog"
      width="350"
    >      
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
            Nuevo Parte
        </v-card-title>
        
        <v-layout wrap align-center mt-2 mb-2>
            <v-flex xs10 offset-xs1>                
                ¿Es usted titular?
            </v-flex>                                
        </v-layout>                
        
        

        <v-card-actions>
            <v-btn
                color="error"
                text
                @click="close"
            >
                No
            </v-btn>
            <v-spacer></v-spacer>          
            <v-btn
                color="primary"
                text
                @click="closeOK"
            >
                Si
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>  
</template>
<script>
export default {
    name: 'dialogConfirmDriver',
    data () {
      return {               
      }
    },
    methods:{        
        close(){
            this.driver = false;
            this.dialog = false;                        
        },
        closeOK(){   
            this.driver = true;         
            this.dialog = false;                        
        }
    },
    mounted(){
    },
    watch:{
    },
    computed:{
        dialog: {
            get(){
                return this.$store.state.dialogConfirmDriver;
            },
            set(value){
                this.$store.state.dialogConfirmDriver = value;
            }
        },
        driver:{
            get(){
                return this.$store.state.driver;
            },
            set(value){
                this.$store.commit('saveDriver', value);
            }
        }
    }
}
</script>

